import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { faqs } from "../../mock";

const FAQ = () => {
  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-5 lg:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700">FAQs</div>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[34px] lg:text-[44px] leading-[1.1]">
            Answers to what procurement teams ask us most
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border border-slate-200 rounded-xl px-5 bg-white data-[state=open]:border-teal-300 data-[state=open]:shadow-sm">
              <AccordionTrigger className="text-left font-display font-bold text-slate-900 text-[16px] py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-[14.5px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
